module.exports = __webpack_public_path__ + "img/fake-user-12.67c5d6a1.png";